import routesAccount from './routes-account'
import routesNovaConta from './routes-nova-conta'
import routesContratar from './routes-contratar'
import routesAreaCliente from './area-cliente/index'
import routesAreaMention from './area-mention/index'
import store from "@/state/store"
import Roles from '@/utils/roles'
import { isInRoles } from "@/utils/authorize.directive"

// A checagem genérica de meta.roles segue comentada no router/index.js, então
// rotas que precisam mesmo barrar acesso por URL usam um beforeEnter próprio.
const requireRole = (role) => (to, from, next) => {
  if (!isInRoles(role)) {
    next({ name: 'home' })
    return
  }
  next()
}

const routes = [
  // Dashboards
  {
    path: "/",
    name: "home",
    meta: { 
      title: "Home", 
      authRequired: true,
      roles: [Roles.AllLoggedUsers] 
    },
    component: () => store.getters['account/isMention'] ? 
      import("@/views/area-mention/home/index.vue") : 
      import("@/views/area-cliente/home/index.vue"),
  },
  {
    path: "/notificacoes",
    name: "area-notificacoes",
    meta: { 
      title: "Notificações", 
      authRequired: true,
      roles: [Roles.AllLoggedUsers] 
    },
    component: () => import("@/views/shared/area-notificacao.vue") ,
  },
  {
    path: "/repositorio-links",
    name: "repositorio-links",
    meta: { 
      title: "Repositório de links",
      authRequired: true,
      roles: [Roles.VisualizarLinks] 
    },
    component: () => import("@/views/area-mention/repositorio-de-links/index.vue") ,
  },
  {
    path: "/meu-perfil",
    name: "meu-perfil",
    meta: { 
      title: "Editar meu perfil", 
      authRequired: true,
      roles: [Roles.AllLoggedUsers]
    },
    component: () => import("@/views/shared/editar-perfil/index.vue") ,
  },
  {
    path: "/atendimento",
    name: "atendimento",
    meta: { 
      title: "Atendimento", 
      authRequired: true,
      roles: []
    },
    component: () => import("@/views/shared/atendimento/index.vue") ,
  },
  {
    path: "/template-plano-comunicacao",
    name: "template-plano-comunicacao",
    meta: { 
      title: "Plano de comunicação", 
      authRequired: true,
      roles: [] 
    },
    component: () => import("@/views/shared/templates-html/template-plano-comunicacao.vue") ,
  },

  {
    path: "/formulario-contatos",
    name: "formulario-contatos",
    meta: {
      title: "Formulário de Contatos",
      authRequired: true,
      roles: [ Roles.CommercialContactForm ]
    },
    beforeEnter: requireRole(Roles.CommercialContactForm),
    component: () => import("@/views/area-mention/formulario-contatos/index.vue") ,
  },
  {
    path: "/clipping",
    name: "clipping",
    meta: { 
      title: "Clipping", 
      authRequired: true,
      roles: [ Roles.Clipping ]
    },
    component: () => import("@/views/area-mention/clipping/index.vue") ,
  },
  {
    path: "/press",
    name: "press",
    meta: { 
      title: "Press", 
      authRequired: true,
      roles: [ Roles.Clipping ]
    },
    component: () => import("@/views/area-mention/press/index.vue") ,
  },

  {
    path: "/beneficios-indicacoes",
    name: "beneficios-indicacoes",
    meta: {
      title: "Programa de indicações",
      authRequired: true,
      roles: [ Roles.CommercialReferrals ]
    },
    beforeEnter: requireRole(Roles.CommercialReferrals),
    component: () => import("@/views/area-mention/beneficios/index.vue") ,
  },

];

export default [
  ...routes, ...routesAreaCliente,
  ...routesAccount, ...routesNovaConta, ...routesContratar, ...routesAreaMention
];
